import { render, staticRenderFns } from "./ReviewAskEntry.vue?vue&type=template&id=6f98f3b8&scoped=true"
import script from "./ReviewAskEntry.vue?vue&type=script&lang=js"
export * from "./ReviewAskEntry.vue?vue&type=script&lang=js"
import style0 from "./ReviewAskEntry.vue?vue&type=style&index=0&id=6f98f3b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f98f3b8",
  null
  
)

export default component.exports